import * as React from 'react'

import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'

import type { ImportedEmployee } from 'modules/employees/lib/ImportedEmployee'

import ImportModal from '../ImportModal'
import TableTabs from './TableTabs'

type WithMultiSelectProps = WithMultiSelectStateChildrenProps<ImportedEmployee>

interface Props {
  employees: ImportedEmployee[]
  selected: ImportedEmployee[]
  attributes: string[]
  customFields: string[]
  onToggleSelectedItem: WithMultiSelectProps['onToggleSelectedItem']
  onDeselectAll: () => void
  onSelectAll: () => void
}

const ImportTable = ({
  employees,
  selected,
  attributes,
  customFields,
  onToggleSelectedItem,
  onDeselectAll,
  onSelectAll,
}: Props) => {
  const [isModalOpen, toggleModal] = React.useState(false)

  return (
    <>
      {isModalOpen && (
        <ImportModal
          allEmployees={employees}
          selectedEmployees={selected}
          onClose={() => toggleModal(false)}
        />
      )}
      <TableTabs
        employees={employees}
        selected={selected}
        attributes={attributes}
        customFields={customFields}
        onToggleSelectedItem={onToggleSelectedItem}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        toggleModal={() => toggleModal(true)}
      />
    </>
  )
}

export default ImportTable
